import { render, staticRenderFns } from "./NewAttendenceMarking.vue?vue&type=template&id=64c2395a"
import script from "./NewAttendenceMarking.vue?vue&type=script&lang=js"
export * from "./NewAttendenceMarking.vue?vue&type=script&lang=js"
import style0 from "./NewAttendenceMarking.vue?vue&type=style&index=0&id=64c2395a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports